import type { ReactNode } from "react";

/** Stroke icons for the sidebar rail, keyed by the nav item's `to` (24x24, decorative). */
const PATHS: Readonly<Record<string, ReactNode>> = {
  "": <path d="M3 11l9-8 9 8M5 10v10h5v-6h4v6h5V10" />,
  // OWN-164: follow-up dashboard (four tiles); `wallet` is used by the attention list.
  wallet: <path d="M3 7h16a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7zM3 7l3-3h10v3M16 14h2" />,
  conversations: <path d="M3 13l2-8h14l2 8M3 13v6h18v-6M3 13h5l1 2h6l1-2h5" />,
  groups: (
    <>
      <circle cx="9" cy="9" r="3" />
      <path d="M3 19c.4-3 2.7-4.5 6-4.5s5.6 1.5 6 4.5M16 6.5a3 3 0 010 5.5M18 14.8c1.8.6 2.8 2 3 4.2" />
    </>
  ),
  channels: (
    <path d="M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1" />
  ),
  contacts: (
    <>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20c.5-3.6 3.2-5.5 6.5-5.5s6 1.9 6.5 5.5M16 4.8a3.5 3.5 0 010 6.4M18 14.8c2 .6 3.2 2.3 3.5 5" />
    </>
  ),
  pipeline: <path d="M4 4h4v16H4zM10 4h4v10h-4zM16 4h4v6h-4z" />,
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4M8 14h2M14 14h2" />
    </>
  ),
  automation: (
    <>
      <rect x="3" y="4" width="6" height="5" rx="1" />
      <rect x="15" y="15" width="6" height="5" rx="1" />
      <path d="M9 6.5h3a3 3 0 013 3v5.5" />
    </>
  ),
  ai: (
    <>
      <path d="M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8L12 3z" />
      <path d="M18.5 15l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2z" />
    </>
  ),
  broadcasts: <path d="M3 11v3l12 5V6L3 11zM15 9a4 4 0 010 6M7 15v4" />,
  "growth/widget": <path d="M3 17l6-6 4 4 8-8M15 7h6v6" />,
  store: <path d="M4 9l1.5-5h13L20 9M4 9h16v11H4V9zM9 20v-6h6v6" />,
  bookings: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4" />
    </>
  ),
  analytics: <path d="M4 20V10M10 20V4M16 20v-8M22 20H2" />,
  settings: <path d="M4 7h10M18 7h2M4 17h2M10 17h10M14 4v6M6 14v6" />,
};

const FALLBACK = <circle cx="12" cy="12" r="3" />;

export function NavIcon({ to }: { readonly to: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className="size-5 shrink-0"
    >
      {PATHS[to] ?? FALLBACK}
    </svg>
  );
}
